import React from 'react';
import Widgets from '../Widgets';
import { LineGraph, LegendIconic, InfoBlock, LegendNumeric, CustomFilter} from '../../../components';
import { isEqual } from 'lodash';

import './WidgetLineGraph.css';

export default class WidgetLineGraph extends Widgets {
  componentDidUpdate(props, state) {
    if (
      (!isEqual(this.props.filters, props.filters) || ((this.state && state) && !isEqual(this.state.extraFilters, state.extraFilters)) || this.props.shouldLoadData)
      && (this.props.filtersLoaded)
    ){
      return this.props.fetchData({
        ...this.props.filters,
        ...(this.state ? this.state.extraFilters : {})
      }, this.props.id)
    }
  }

  onCustomFilterChange = (items) => {
    const extraFilters = items.reduce((acc, curr) => ({
      ...acc,
      ...(curr.value.split('=').length === 2 && this.props.customFilterAcceptedParams.includes(curr.value.split('=')[0]) ? {[curr.value.split('=')[0]]: curr.value.split('=')[1]} : {})
    }), {});
    this.setState({ extraFilters, selectedFilters: items.filter(item => item.value.split('=').length === 2 && this.props.customFilterAcceptedParams.includes(item.value.split('=')[0])) });
  }

  render() {
    if (this.props.loaded)
      return (
        <div className={this.props.className ? `${this.props.className} WidgetLineGraph` : 'WidgetLineGraph'} style={this.props.style}>
          <h1 className="title">{this.props.title}</h1><span className="actions">{this.props.onZoom ? <a onClick={this.props.onZoom}><i className="fa fa-search"></i></a> : null}<a onClick={this.downloadDataAsCSV}><i className="fa fa-download"></i></a></span>
          {this.props.customFilter ? <CustomFilter className="CustomFilter" selected={this.state && this.state.selectedFilters ? this.state.selectedFilters : []} onChange={this.onCustomFilterChange} acceptedParams={this.props.customFilterAcceptedParams} /> : null}
          <div style={this.props.id === 'WidgetVisits' || 'WidgetConversion' ? {'width': '80%', 'float': 'left'} : {'width': '80%', 'float': 'left', marginTop: '20px'}}>
            {this.props.keys && this.props.keys.length ? <LegendNumeric colorScheme={this.props.colorScheme} keys={this.props.keys} size={[this.props.width * 0.9, 50]} /> : null}
            <LineGraph
              colorScheme={this.props.colorScheme}
              data={this.props.graph}
              size={this.props.id === 'WidgetVisits' ? [this.props.width * 0.8, this.props.height * 0.67] : [this.props.width * 0.8, this.props.height * 0.7]}
              filters={{
                ...this.props.filters,
                ...(this.state ? this.state.extraFilters : {})
              }}
              {...(this.props.drillOptions ? { drillOptions: this.props.drillOptions } : {})}
              {...(this.props.drillData ? { drillData: this.props.drillData } : {})}
              id={this.props && this.props.id ? this.props.id : null}
            />
          </div>
          <div className="infoBlocks" style={this.props.id === 'WidgetUnsubs' ?
            {'width': this.props.width * 0.17, 'height': '70%', 'overflow-y': 'scroll','top':'calc(50% - 35%)'} :
            {'width': this.props.width * 0.15, bottom : '30%'}}>
            {this.props.rightLegend ? <LegendIconic {...this.props.rightLegend} /> : null}
              {this.props.info ? this.props.info.map((item, idx) => (
                <div>
                  {idx !== 0 ? <hr /> : null}
                  <InfoBlock {...item} />
                </div>
              )) : null}
          </div>
        </div>
      );
    else if (!this.props.loaded && this.props.filtersLoaded)
      return (
        <div className={this.props.className ? `${this.props.className} WidgetLineGraph` : 'WidgetLineGraph'} style={this.props.style}>
          <img src={`${process.env.PUBLIC_URL}/loading.svg`} />
        </div>
      );
    else
      return (
        <div className={this.props.className ? `${this.props.className} WidgetLineGraph` : 'WidgetLineGraph'} style={this.props.style}>
          <h1>select operator and service to see stats</h1>
        </div>
      );

  }
}



// WEBPACK FOOTER //
// ./src/components/Widgets/WidgetLineGraphComponent/WidgetLineGraph.js